import { Music } from "../../Util/Music/Music"
import "./IntervalNames.scss"

export function IntervalNames(){
    const names:string[] = Music.IntervalNames
    return(
        <div className={'interval-names what'}>
            <div className={'interval-names-container'}>
               { 
                    names.map((name:string, index:number)=>{
                        if(index === 0){return}
                        return <div className={'interval-name'}>{index} : {name}</div>
                    })
                }
            </div>
        </div>
    )
}